import gql from 'graphql-tag';

export const DELETE_WATCHLIST_MUTATION = gql`
  mutation DeleteWatchlist($id: Int!) {
    deleteWatchlist(id: $id)
  }
`;
